import $api from "@api/$api";
import aspida from "@aspida/axios";
import { environment } from '@environments/environment';

export const client = $api(aspida(undefined,{baseURL:environment.APIPrefix}));
export type Client = typeof client;
